import React from 'react'
import { Outlet } from 'react-router-dom'
import { NavBar } from '../../components/common/NavBar'
import { useIsMobile } from '../../hooks/useIsMobile'

const Root = (): JSX.Element => {
  // usePageViews depends on useHistory which must be placed inside <Router>
  const isMobile = useIsMobile()

  return (
    <div className="flex h-full flex-col">
      <div className="print:hidden">
        <NavBar />
      </div>
      <div
        style={{ height: `calc(100vh - ${isMobile ? 52 : 64}px)` }}
        className="flex w-full print:!h-auto"
      >
        <Outlet />
      </div>
    </div>
  )
}

Root.displayName = 'Root'
export { Root }
